import React, { useState } from 'react'
import { Button, Container, Row } from 'react-bootstrap';
import SunglassesCard from '../SunglassesCard/SunglassesCard';
import './SunglassesSection.css';

const SunglassesSection = () => {
    const GUNMETAL_IMAGES = [
        {
            src: '/kids-rayban.png',
            title: "Ray-Ban ",
            desc: "Kids"
        },
        {
            src: '/sunglasses-versace.png',
            title: "Versace",
            desc: "Sunglasses"
        },
        {
            src: '/sunglasses-carrera.png',
            title: "Carrera",
            desc: "Sunglasses"
        },
        {
            src: '/sunglasses-versace-2.png',
            title: "Versace",
            desc: "Sunglasses"
        },
        {
            src: '/sunglasses-dolce&gabbana.png',
            title: "Dolce & Gabbana",
            desc: "Sunglasses"
        },
        {
            src: '/sunglasses-marcjacob.png',
            title: "Marc Jacobs",
            desc: "Sunglasses"
        },
        {
            src: '/sunglasses-versace-3.png',
            title: "Versace",
            desc: "Sunglasses"
        },
        {
            src: '/kids-rayban-2.png',
            title: "Ray-Ban",
            desc: "Kids"
        },

    ];
    const [startIndex, setStartIndex] = useState(0);
    const itemsPerPage = 4;

    const handlePrev = () => {
        setStartIndex(prev => Math.max(prev - itemsPerPage, 0));
    };

    const handleNext = () => {
        setStartIndex(prev =>
            Math.min(prev + itemsPerPage, GUNMETAL_IMAGES.length - itemsPerPage)
        );
    };

    const visibleItems = GUNMETAL_IMAGES.slice(startIndex, startIndex + itemsPerPage);

    return (
        <section className="sunglasses-section">
            <div className="sunglasses-bg-overlay" />
            <Container className='z-3'>
                <section className="sunglassesCard-section">
                    <div className="text-center d-flex flex-column align-items-center mb-4">
                        <h2 className="sunglasses-title">Explore Our Designer Eyewear Collection</h2>
                        <p className="sunglasses-lead">Find frames that match your style and personality. From timeless classics to bold fashion statements, Elite Optix offers eyewear that defines you.</p>
                    </div>
                    <div className="sunglasses-nav">
                        <Button variant="light" className="sunglasses-cta prev" aria-label="Previous" onClick={handlePrev} disabled={startIndex === 0}>
                            <img src="/icons/arrow.png" alt="previous" />
                        </Button>
                        <Button variant="light" className="sunglasses-cta next" aria-label="Next" onClick={handleNext} disabled={startIndex + itemsPerPage >= GUNMETAL_IMAGES.length}>
                            <img src="/icons/arrow.png" alt="next" />
                        </Button>
                    </div>

                    <Row className="g-4">
                        {visibleItems.map((src, idx) => (

                            <SunglassesCard key={src} src={src} idx={idx} />
                        ))}
                    </Row>
                </section>
            </Container>
        </section>
    )
}

export default SunglassesSection